import { IRecentlyViewedOffer } from '../../types/recentlyViewedOffer';
import { ITypedReduxAction } from '../../types/redux/actionType';

export enum EOffersFromHistoryActionTypes {
  Set = 'OffersFromHistory/SET',
}

export interface IOffersFromHistoryPayload {
  recentlyViewed: IRecentlyViewedOffer[];
}

export type TOffersFromHistorySet = ITypedReduxAction<EOffersFromHistoryActionTypes.Set, IOffersFromHistoryPayload>;

export type TOffersFromHistoryActions = TOffersFromHistorySet;
